import fail from './fail.json'
import wait from './wait.json'
import success from './success.json'
export {
  fail,
  wait,
  success
}